var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoirFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 2.66602H18.6667C16.8986 2.66602 15.2029 3.36839 13.9526 4.61864C12.7024 5.86888 12 7.56457 12 9.33268V13.3327H8V18.666H12V29.3327H17.3333V18.666H21.3333L22.6667 13.3327H17.3333V9.33268C17.3333 8.97906 17.4738 8.63992 17.7239 8.38987C17.9739 8.13983 18.313 7.99935 18.6667 7.99935H22.6667V2.66602Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirFacebook);
export default __webpack_public_path__ + "static/media/iconoir_facebook.babf2ce59d3c1814ea99384d094a4c05.svg";
export { ForwardRef as ReactComponent };